<div class="filter-group" data-group-visibility-id="showUniqueGeneralSettings">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showUniqueGeneralSettings" (click)="filter.groupVisibility.showUniqueGeneralSettings = !filter.groupVisibility.showUniqueGeneralSettings; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="General">
          Configure how uniques are divided into tiers and which class-specific uniques to show.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showUniqueGeneralSettings) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showUniqueGeneralSettings">
      <div class="filter filter-property filter-padded-left" style="width: 100%;">
        <span class="filter-body">
          <span filter-title text="Unique Tiering Mode">
            This determines how Uniques are divided into tiers, by changing the cutoff values for each of the tiers. Define your own Tiering Mode or review and customize which uniques is in which tier on the <a href="/tier-list/uniques">Uniques Tier List</a> tab.
          </span>
          <span class="sep"></span>
          <app-select [class.include-comparator]="false" [(ngModel)]="filter.uniquesTieringMode" (selectedValueChange)="uniqueTieringModeChanged($event)">
            <app-option [value]="'Normal'" [text]="'Normal'"></app-option>
            <app-option [value]="'Strict'" [text]="'Strict'"></app-option>
            <app-option [value]="'VeryStrict'" [text]="'Very Strict'"></app-option>
            <app-option [value]="'Custom'" [text]="'Custom'"></app-option>
          </app-select>
          @if (filter.uniquesTieringMode === 'Custom') {
            <span class="sep"></span>
            <button class="btn toggle-button show-filters-button" (click)="openCustomTieringDialog()">
              <span class="icon icon-equalizer"></span>
            </button>
          }
        </span>
      </div>

      <div class="filter filter-property filter-padded-left" style="width: 100%;">
        <span class="filter-body">
          <span filter-title text="Class-specific Uniques">
            <span class="unique-item-color">Class-specific</span> Uniques are cheap but often-used uniques by the specified class. They are styled as <span class="unique-item-color">Potential</span> Uniques. Good for SSF and when you don't want to show <i>All</i> Uniques.
            <br /><br />Head over to the <a href="/tier-list/uniques">Uniques Tier List</a> tab to move them to the desired tier.
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [allLabel]="'None'"
            [options]="classes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="filter.showClassSpecificUniquesForClasses"
            (selectedValuesChange)="filter.showClassSpecificUniquesForClasses = $event; rebuildTierList();"></app-autocomplete>
        </span>
      </div>

      <div class="filter filter-property filter-padded-left" style="width: 100%;">
        <span class="filter-body">
          <span filter-title text="Favourite Endgame Content" ruleId="uniques-restricted-favourite-bosses">
            Select which endgame content you occasionally engage with. This ensures that valuable drop-restricted uniques from this content will stay highlighted.
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [allLabel]="'All'"
            [options]="endgameContentOptions"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="favouriteEndgameContentSelection"
            (selectedValuesChange)="favouriteEndgameContentChangedHandler($event)"></app-autocomplete>
        </span>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>

@if (showCustomTieringDialog) {
  <app-custom-uniques-tiering-mode-dialog
    [filter]="filter"
    (close)="closeCustomTieringDialog()">
  </app-custom-uniques-tiering-mode-dialog>
}
